import { connect } from 'react-redux';
import { actions } from '@ehi/global-marketing-interface';
import MODAL from 'constants/modals';
import { toJS } from 'utils/hoc';
import { updateProfileInRes, onlineCheckinProfileAbort } from 'actions/checkin';
import { isLoyaltyReservationSelector } from 'selectors/reservationSelectors';
import {
  isSkipTheCounterCompletedReservationSelector,
  isCheckedInReservationSelector,
} from 'selectors/reservationFlowSelectors';

import {
  getProfileFound,
  getOnlineCheckInProfileOciEligible,
  getHasOnlineCheckInProfile,
  isUnauthUserWithLoyaltyProfileSelector,
  isUnauthPartialProfileSelector,
  isResFirstNameDifferentThanOciProfileSelector,
  onlineCheckInProfileSelector,
} from 'selectors/checkinSelectors';
import { authenticatedSelector, isNonLoyaltyProfileSelector } from 'selectors/profileSelectors';
import { openModal } from 'actions/modal/openModal';
import { searchProfileByDriverLicense } from 'actions/profile';
import { inResAccelerateCheckInRadioButton } from 'actions/reservation/inResAccelerateCheckInRadioButton';

import CheckInCard from './CheckInCard';

const mapStateToProps = (state) => {
  const isSkippingTheCounter = isSkipTheCounterCompletedReservationSelector(state);
  const ociEligible = getOnlineCheckInProfileOciEligible(state);
  const isResOCIActivated = isCheckedInReservationSelector(state);
  const isLoyaltyReservation = isLoyaltyReservationSelector(state);
  const hasOnlineCheckInProfile = getHasOnlineCheckInProfile(state);
  const isProfileFound = getProfileFound(state);
  const profile = onlineCheckInProfileSelector(state);
  const isUnauthUserWithLoyaltyProfile = isUnauthUserWithLoyaltyProfileSelector(state);
  const isAuth = authenticatedSelector(state);

  const isUnauthPartialProfile = isUnauthPartialProfileSelector(state);

  const isResFirstNameDifferentThanOciProfile = isResFirstNameDifferentThanOciProfileSelector(state);
  const isNonLoyaltyProfileFound = isNonLoyaltyProfileSelector(state);
  return {
    isSkippingTheCounter,
    ociEligible,
    isResOCIActivated,
    isLoyaltyReservation,
    hasOnlineCheckInProfile,
    isProfileFound,
    profile,
    isUnauthUserWithLoyaltyProfile,
    isAuth,
    isUnauthPartialProfile,
    isResFirstNameDifferentThanOciProfile,
    isNonLoyaltyProfileFound,
  };
};

const mapDispatchToProps = {
  inResAccelerateCheckInRadioButton,
  searchProfileByDriverLicense,
  cleanMessages: actions.cleanMessages,
  openSignInModal: () =>
    openModal(MODAL.SIGN_IN_MODAL, {
      props: {
        stashAnalytics: false,
      },
    }),
  onlineCheckinProfileAbort,
  updateProfileInRes,
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CheckInCard));
